import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';
import { OrganisationTreeService, UserService, RolePermissions } from 'shared/domain';
import { NamePipe } from 'shared/util-common';

import { AuthService } from '@treetop/authentication';

import { InitialsPipe } from '../../../../../util-common/src/lib/pipes/initials.pipe';
import { AvatarComponent } from '../avatar/avatar.component';
import { IconDirective } from '../icon/icon.directive';
import { MenuItemDirective } from '../menu/menu-item.directive';
import { MenuTriggerDirective } from '../menu/menu-trigger.directive';
import { MenuComponent } from '../menu/menu.component';
import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  standalone: true,
  selector: 'tt-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    TranslocoModule,
    RouterModule,
    IconDirective,
    MenuComponent,
    MenuItemDirective,
    MenuTriggerDirective,
    AvatarComponent,
    TooltipDirective,
    InitialsPipe,
    NgxPermissionsModule,
    NamePipe,
  ],
})
export class UserInfoComponent {
  protected authService = inject(AuthService);
  protected userService = inject(UserService);
  protected organisationTreeService = inject(OrganisationTreeService);

  public disabled = input(false);

  protected currentUser = toSignal(this.userService.currentUser$);

  protected currentRootOrganisationId = computed(() => {
    const currentUser = this.currentUser();
    return currentUser?.currentRootOrganisation?.id;
  });

  protected setCurrentRootOrganisation(organisationId: string) {
    this.userService.updateRootOrganisation(organisationId);
  }

  protected onLogout(): void {
    this.authService.logout();
  }

  protected readonly RolePermissions = RolePermissions;
}
